var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 591,
    viewBox: "0 0 257 591",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 257.767,
    cy: 257.767,
    r: 257.767,
    transform: "matrix(-1 0 0 1 256.285 0)",
    fill: "#E6889F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.767,
    cy: 257.767,
    r: 257.767,
    transform: "matrix(-1 0 0 1 226.281 15.457)",
    fill: "#FFDD89"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.767,
    cy: 257.767,
    r: 257.767,
    transform: "matrix(-1 0 0 1 196.275 30.9138)",
    fill: "#EAA7B8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.767,
    cy: 257.767,
    r: 257.767,
    transform: "matrix(-1 0 0 1 166.271 46.3707)",
    fill: "#445597"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.767,
    cy: 257.767,
    r: 257.767,
    transform: "matrix(-1 0 0 1 136.268 61.8276)",
    fill: "#1D2A54"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.767,
    cy: 257.767,
    r: 257.767,
    transform: "matrix(-1 0 0 1 103.535 75.4661)",
    fill: "#F9BEB2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle2);
export default __webpack_public_path__ + "static/media/circle-2.5a7349fb61bc155a61d5be952a164e13.svg";
export { ForwardRef as ReactComponent };